(function (window, document) {
  function closeDropdown() {
    $("#tags-dropdown-panel").removeClass("open");
    $(".tags .overlay").hide();

    $("body").css("overflow", "auto");

    $(".tags .overlay").on("click", closeDropdown);
  }

  function resize() {
    if ($(window).width() > 768) {
      $(window).off("resize", resize);
      closeDropdown();
    }
  }

  $(".tags .dropdown").on("click", function () {
    if ($("#tags-dropdown-panel").hasClass("open") === false) {
      $("body").css("overflow", "hidden");

      $("#tags-dropdown-panel").addClass("open");

      $(".tags .overlay").on("click", closeDropdown);
      $(window).on("resize", resize);

      $(".tags .overlay").show();
    }
  });
})(window, document);
